import React from 'react'

import { useFileUploadInputState } from './hooks/useFileUploadInputState'

type FileUploadInputRef = HTMLInputElement

type FileUploadInputProps = {}

export const FileUploadInput = React.forwardRef<FileUploadInputRef, FileUploadInputProps>(
    (_props, ref) => {
        const {
            disabled,
            inputId,
            dropzoneId,
            labelId,
            accept,
            name,
            multiple,
            required,
            onChange,
        } = useFileUploadInputState()

        return (
            <>
                <input
                    type="file"
                    id={inputId}
                    aria-labelledby={labelId}
                    aria-describedby={dropzoneId}
                    ref={ref}
                    tabIndex={-1}
                    accept={accept}
                    name={name}
                    className="sr-only"
                    disabled={disabled}
                    multiple={multiple}
                    required={required}
                    onChange={onChange}
                />
                <span id={labelId} className="sr-only">
                    File upload
                </span>
            </>
        )
    }
)
